<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">User Rights Management</h1>
    <app-navpath class="hidden md:block"></app-navpath>
  </div>
  <label class="my-4 flex flex-wrap items-center justify-end gap-3">
    Individual Selection
    <label class="switch">
      <input
        type="checkbox"
        [(ngModel)]="individual"
        (ngModelChange)="onIndividualChange($event)"
      />
      <span class="slider round"></span>
    </label>
  </label>
  <div class="content-container" [hidden]="individual">
    <h2 class="sub-heading w-full border-b">Rights Replication</h2>
    <div class="replication-cols">
      <section
        class="content-container rounded bg-gray-100 p-4 shadow"
      >
        <h3 class="sub-heading w-full border-b">Reference User</h3>
        <app-data-form
          [dataFields]="referenceUserFields"
          [dataName]="'referenceUserFields'"
          [columns]="1"
          (updateFields_child)="handleReferenceUpdate($event)"
        ></app-data-form>
      </section>
      <section
        class="content-container rounded bg-gray-100 p-4 shadow"
      >
        <h3 class="sub-heading w-full border-b">Target User</h3>
        <app-data-form
          [dataFields]="targetUserFields"
          [dataName]="'targetUserFields'"
          [columns]="1"
          (updateFields_child)="handleTargetUpdate($event)"
        ></app-data-form>
      </section>
    </div>
    <div class="mb-2 mt-4 flex w-full flex-col gap-1 md:w-fit md:flex-row">
      <button
        class="shorter-btn misc-btn"
        [disabled]="!isReplicationValid() || replicationSuccessful"
        (click)="replicateRights()"
      >
        <fa-icon [icon]="faCopy" class="mr-1"></fa-icon>Replicate
        Rights
      </button>
      <button class="shorter-btn clear-btn" (click)="clearReplication()">
        <fa-icon [icon]="faEraser" class="mr-1"></fa-icon>Clear
      </button>
    </div>
  </div>
  <div class="content-container" [hidden]="!individual">
    <section class="content-container">
      <div class="grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        <app-select-input
          class="block w-full"
          [dataInput]="upperFormFields[0].value"
          [selectOptions]="upperFormFields[0].options || []"
          [id]="upperFormFields[0].id"
          (dataOutput)="
            handleUpdate({
              fields: [{ id: upperFormFields[0].id, value: $event }],
              updatedValue: 0
            })
          "
        ></app-select-input>
        <app-select-input
          class="block w-full"
          [dataInput]="upperFormFields[1].value"
          [selectOptions]="upperFormFields[1].options || []"
          [id]="upperFormFields[1].id"
          (dataOutput)="
            handleUpdate({
              fields: [{ id: upperFormFields[1].id, value: $event }],
              updatedValue: 0
            })
          "
        ></app-select-input>
        <app-text-input
          class="block w-full"
          dataType="text"
          [dataInput]="upperFormFields[2].value || ''"
          [id]="upperFormFields[2].id"
          (dataOutput)="
            handleUpdate({
              fields: [{ id: upperFormFields[2].id, value: $event }],
              updatedValue: 0
            })
          "
        ></app-text-input>
      </div>
    </section>
    <div class="content-container">
      <div class="w-full overflow-x-auto">
        <app-data-table
          class="block min-w-[56rem]"
          [tableHeaders]="tableHeaders"
          [tableEntries]="filteredTypesSelect"
          (checkChange)="checkEntry($event)"
          [pagination]="false"
        ></app-data-table>
      </div>
    </div>
    <div class="mb-2 mt-4 flex w-full flex-col gap-1 md:w-fit md:flex-row">
      <button
        class="shorter-btn misc-btn"
        [disabled]="!selectedUserId || types_select.length === 0"
        (click)="updateUserRights()"
      >
        <fa-icon [icon]="faPencil" class="mr-1"></fa-icon>Update
      </button>
    </div>
  </div>
</section>
